import { CircularProgress } from '@material-ui/core'
import React, { FC } from 'react'
import styled from 'styled-components'

const ProgressContainer = styled.div`
  width: 20px;
  flex: 0;
  margin-left: 10px;
`

export const ToggleProgress: FC<{ isSubmitting: boolean }> = ({ isSubmitting }) => {
  return <ProgressContainer>{isSubmitting && <CircularProgress size={16} />}</ProgressContainer>
}
